import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha-2';
import { environment } from '../environments/environment';
import { ToastErrorHandler } from './core/toast-error-handler.service';
import { ApplicationInfoService } from './core/application-info.service';
import { AuthService } from './core/auth.service';
import { JwtInterceptor } from './core/jwt.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            routes,
            withComponentInputBinding(),
            withViewTransitions(),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),
        provideHttpClient(),
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.recaptcha.siteKey
            } as RecaptchaSettings
        },
        // { provide: 'googleTagManagerId', useValue: 'GTM-TZWVFWTM' },
        // { provide: 'googleTagManagerId', useValue: 'G-X5PKQ07QVF' },
        { provide: ErrorHandler, useClass: ToastErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        provideAppInitializer(async () => {
            const authService = inject(AuthService);
            const result = await authService.refreshToken();
            // console.log('refreshToken', result);
        }),
        provideAppInitializer(async () => {
            const appInfo = inject(ApplicationInfoService);
            await appInfo.getApplicationInfo();
        })
    ]
};
